import toast from "react-hot-toast";
import {
  cancelSession,
  createGlb,
  createObject,
  createPhotography,
  objectConservationCreation,
  objectConservationStatus,
} from "../../../../api/actions/object";
import { clearAutoSavedFromIndexedDB } from "../../../../indexdb/autosaveIndex";
import { hasOtherFieldValue } from "../../../../pages/ObjectConservation/conservationUtils";

export const overRideConfirmHandlerAutosave = async (
  savedDataFromIndex,
  setIsSaving,
  setAutoSaveError,
  setSavedDataFromIndex
) => {
  if (savedDataFromIndex.collection) {
    setIsSaving({
      collection: true,
    });
    const payload = {
      ...savedDataFromIndex.collection,
      is_override: true,
    };
    setAutoSaveError(false);
    createObject(payload)((response) => {
      if (response?.status) {
        toast.success("Object updated successfully");
        setIsSaving({
          collection: false,
        });
      } else {
        setIsSaving({
          collection: false,
        });
        toast.error(response?.message);
      }
    });
    setSavedDataFromIndex({ collection: null });
    await clearAutoSavedFromIndexedDB("collection");
  } else if (savedDataFromIndex.digital) {
    const digitalDataDb = savedDataFromIndex.digital;
    setIsSaving({
      digital: true,
    });
    setAutoSaveError(false);
    createPhotography({
      id: digitalDataDb?.id,
      images: digitalDataDb?.images,
      session: digitalDataDb?.digitalSession,
      is_override: true,
    })((response) => {
      if (response?.status) {
        toast.success("Object updated successfully");
        setIsSaving({
          digital: false,
        });
      } else {
        setIsSaving({
          digital: false,
        });
        toast.error(response?.message);
      }
    });

    let formDataDigital = new FormData();
    formDataDigital.append("id", digitalDataDb.id);
    if (digitalDataDb?.image_id) {
      formDataDigital.append("image_id", digitalDataDb?.image_id);
    } else {
      formDataDigital.append("image_id", "");
    }
    if (digitalDataDb?.file) {
      formDataDigital.append("file", digitalDataDb.file);
    } else if (digitalDataDb?.url || digitalDataDb.glb_image) {
      formDataDigital.append(
        "url",
        digitalDataDb.url || digitalDataDb.glb_image
      );
    } else {
      formDataDigital.append("url", "");
      formDataDigital.append("file", "");
    }
    formDataDigital.append("image_position", digitalDataDb?.image_position);
    formDataDigital.append("image_changed", digitalDataDb?.image_changed);
    createGlb(formDataDigital)((response) => {
      if (response?.status) {
      } else {
        toast.error(response?.message);
      }
    });
    setSavedDataFromIndex({ digital: null });
    await clearAutoSavedFromIndexedDB("digital");
  } else if (savedDataFromIndex.conservation) {
    const conservationDataDb = savedDataFromIndex.conservation;
    setAutoSaveError(false);
    setIsSaving({
      conservation: true,
    });
    const payload = {
      ...conservationDataDb,
      is_override: true,
    };
    objectConservationCreation(payload)((response) => {
      if (response?.status) {
        const currentStatus =
          conservationDataDb?.object_details?.conservation_status;

        let nextStatus = currentStatus;

        // 🚫 once in conservation → locked forever
        if (currentStatus === "in_conservation") {
          nextStatus = "in_conservation";
        }

        // to_do → in_conditional_assessment
        else if (
          currentStatus === "to_do" &&
          conservationDataDb?.remarks &&
          (conservationDataDb?.stability || conservationDataDb?.is_emergency)
        ) {
          nextStatus = "in_conditional_assessment";
        }

        // in_conditional_assessment → in_conservation
        else if (
          currentStatus === "in_conditional_assessment" &&
          hasOtherFieldValue(conservationDataDb)
        ) {
          nextStatus = "in_conservation";
        }
        // if (nextStatus !== currentStatus) {
        objectConservationStatus({
          id: conservationDataDb?.id,
          conservation_status: nextStatus,
        })((response) => {
          if (response?.status) {
            // success
          }
        });
        // }
        setIsSaving({
          conservation: false,
        });
        toast.success("Object updated successfully");
      } else {
        setIsSaving({
          conservation: false,
        });

        toast.error(response?.message);
      }
    });

    setSavedDataFromIndex({ conservation: null });
    await clearAutoSavedFromIndexedDB("conservation");
  }
};

export const overRideCancelHandlerAutosave = async (
  savedDataFromIndex,
  setSavedDataFromIndex,
  setAutoSaveError
) => {
  const entries = Object.entries(savedDataFromIndex || {});
  if (!entries.length) return;

  for (const [key, data] of entries) {
    if (data?.session) {
      cancelSession({ id: data.session })((cancelResponse) => {
        setAutoSaveError(false);
      });

      // Clear corresponding IndexedDB entry if applicable
      if (["collection", "digital", "conservation"].includes(key)) {
        await clearAutoSavedFromIndexedDB(key);
        setSavedDataFromIndex((prev) => ({ ...prev, [key]: null }));
      }
    }
  }
};
